import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class ProductTypeService {
    static getProductTypes(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`product-types?filter=${qs}`, pageNumber));
    }
    static fetchProductType(oid) {
        return lastValueFrom(BaseService.get(`product-types/${oid}`));
    }
    static saveProductType(dto) {
        return lastValueFrom(BaseService.save(`product-types`, dto));
    }
    static deleteProductType(oid) {
        return lastValueFrom(BaseService.delete(`product-types/${oid}`));
    }
    static searchProductTypeCombo(selfId, phaseCode, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`product-types-search-dropdown/${selfId}/${phaseCode}?search=${qs}`));
    }
}
